import { success, failure, request } from 'app/actions';
import * as actions from './classesStudentsActions';
import * as helpers from './classesStudentsHelpers';

const initialState = {
  applicationOptions: [],
  statusOptions: [],
  schoolOptions: [],
  groups: [],
  years: [],
  schools: [],
  isLoading: false,
  hasError: false,
  massiveGroup: {
    hasError: false,
    warnings: [],
    error: '',
  },
  removeGroupError: false,
  removeGroupErrorMessage: '',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case request(actions.GET_GROUPS):
    case request(actions.GET_SCHOOLS):
    case request(actions.MASSIVE_LOAD_GROUPS):
      return {
        ...state,
        isLoading: true,
        hasError: false,
        massiveGroup: {
          hasError: false,
          warnings: [],
          error: '',
        },
      };
    case success(actions.GET_GROUPS):
      return {
        ...state,
        groups: action.payload.content,
        schoolOptions: helpers.getSchoolOptions(action.payload.content),
        years: helpers.getYears(action.payload.content),
        isLoading: false,
      };
    case success(actions.GET_SCHOOLS):
      const schools = action.payload.content.map((s) => ({
        ...s,
        value: s.idCSchool,
        label: s.name,
      }));
      return {
        ...state,
        schools,
        // isLoading: false,
      };
    case success(actions.MASSIVE_LOAD_GROUPS):
      return {
        ...state,
        isLoading: false,
        massiveGroup: {
          success: true,
          hasError: false,
          warnings: action.payload.warnings,
        },
      };
    case failure(actions.GET_GROUPS):
      return {
        ...state,
        groups: [],
        isLoading: false,
        hasError: true,
      };
    case failure(actions.GET_SCHOOLS):
      return {
        ...state,
        schools: [],
        isLoading: false,
        hasError: true,
      };
    case failure(actions.MASSIVE_LOAD_GROUPS):
      return {
        ...state,
        isLoading: false,
        massiveGroup: {
          success: false,
          hasError: true,
          errors: action.payload.errors,
          error: action.payload.error,
        },
      };
    case actions.RESET_MASSIVE_LOAD_GROUPS:
      return {
        ...state,
        massiveGroup: {
          success: false,
          hasError: false,
        },
      };
    case request(actions.REMOVE_GROUP):
      return {
        ...state,
        removeGroupErrorMessage: initialState.removeGroupErrorMessage,
        removeGroupError: initialState.removeGroupError,
      };
    case success(actions.REMOVE_GROUP):
      return {
        ...state,
        removeGroupErrorMessage: initialState.removeGroupErrorMessage,
        removeGroupError: initialState.removeGroupError,
      };
    case failure(actions.REMOVE_GROUP):
      return {
        ...state,
        removeGroupErrorMessage: action.payload.error,
        removeGroupError: true,
      };
    default:
      return state;
  }
};

export default reducer;
